export const formatAndValidateEmail = (input) => {
  console.log('formatAndValidateEmail called', input)

  if (typeof input !== 'string') return null;

  // Remove all whitespace (not just trim)
  const cleaned = input.replace(/\s+/g, '');

  // Basic email regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(cleaned) ? cleaned : null;
};
